import React from "react";
import { KlimaContent } from "./components/KlimaContent";
import { AnimatePresence } from "framer-motion";

export interface Answer {
  food?: number;
  carType?: number;
  carDistance?: number;
  family?: number;
  leisure?: number;
  airplaneFrequency?: number;
  equipment?: number;
}

export const WidthContext = React.createContext(0);
export const EaseContext = React.createContext("anticipate");
export const AnswerContext = React.createContext({
  answer: {} as Answer,
  setAnswer: (answer: Answer) => { },
});

function App() {
  const [answer, setAnswer] = React.useState({});

  return (
    <WidthContext.Provider
      value={window.innerWidth > 440 ? 440 : window.innerWidth}
    >
      <EaseContext.Provider value={"linear"}>
        <AnswerContext.Provider value={{ answer, setAnswer }}>
          <KlimaContent />
        </AnswerContext.Provider>
      </EaseContext.Provider>
    </WidthContext.Provider>
  );
}

export default App;
